type LoadingHandler = (isLoading: boolean) => void;

let loadingHandler: LoadingHandler | null = null;

export const setLoadingHandler = (handler: LoadingHandler | null) => {
  loadingHandler = handler;
};

export const triggerLoading = (isLoading: boolean) => {
  if (loadingHandler) {
    loadingHandler(isLoading);
  }
};
